import React from 'react';
import { Link as RouterLink, useRouteMatch } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import { Box, Button, Grid } from '@material-ui/core';
import { Method } from '../../routePaths';
import { PaddedContainer } from '../../ui-kit';
import { DiscountTable } from '../../modules';

const DiscountListView = () => {
    const { url } = useRouteMatch();
    return (
        <PaddedContainer spacing={3}>
            <Grid item xs={12}>
                <Box mb={2} display="flex" justifyContent="flex-end">
                    <Button
                        startIcon={<AddIcon />}
                        component={RouterLink}
                        to={`${url}${Method.CREATE}`}
                        variant="contained"
                        color="primary"
                    >
                        New discount
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <DiscountTable />
            </Grid>
        </PaddedContainer>
    );
};

export default DiscountListView;
